import { useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '../../../lib/supabase'
import { reportUnexpectedError } from '../../../lib/reportError'

export function useAnonymiseMember() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (memberId: string) => {
      const { data: { session } } = await supabase.auth.getSession()
      if (!session) throw new Error('unauthorized')

      const response = await supabase.functions.invoke('anonymise-member', {
        body: { memberId },
      })

      if (response.error) {
        reportUnexpectedError(response.error)
        throw response.error
      }

      const result = response.data as { success: boolean; error?: string }
      if (!result.success) {
        const failure = new Error(result.error ?? 'unknown_error')
        reportUnexpectedError(failure)
        throw failure
      }

      return result
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['admin-member-search'] })
    },
  })
}